import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RegisterComponent } from './register/register.component';
import { DiscComponent } from './disc/disc.component';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NavbarComponent } from './page/navbar/navbar.component';
import { AutoLoginComponent } from './page/auto-login/auto-login.component';
import { VersionComponent } from './version/version.component';
import { SidebarComponent } from './page/sidebar/sidebar.component';
import { Error401Component } from './page/error/error401/error401.component';


@NgModule({
  declarations: [
    AppComponent,
    RegisterComponent,
    DiscComponent,
    NavbarComponent,
    AutoLoginComponent,
    VersionComponent,
    SidebarComponent,
    Error401Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
